import React, { useState } from 'react';

import styled from 'styled-components';

import Button from 'Components-redesign/Button';
import { Calendar } from 'Components-redesign/Calendar';
import { useDates } from 'Hooks';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 400px;
  text-align: center;
`;

const CalendarModal = ({ isOpen, onClose, onSubmit }) => {
  const dates = useDates();
  const [calendarStartDate, setCalendarStartDate] = useState<Date>(dates.getStartOfCurrentMonth());
  const [calendarEndDate, setCalendarEndDate] = useState<Date>(dates.getToday());

  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <Calendar
          range
          selectedDates={[calendarStartDate, calendarEndDate]}
          minDate={new Date('2022-06-01')}
          maxDate={new Date()}
          setSelectedDates={(selectedDates) => {
            selectedDates[0] && setCalendarStartDate(selectedDates[0]);
            selectedDates[1] && setCalendarEndDate(selectedDates[1]);
          }}
        />
        <Button
          type="button"
          text={'Submit'}
          styleType="Dark"
          style={{ marginTop: '16px' }}
          handleClick={() => onSubmit(calendarStartDate, calendarEndDate)}></Button>
      </ModalContent>
    </ModalOverlay>
  );
};

export default CalendarModal;
